import { useEffect, useRef, type RefObject } from 'react'

const CLICK_THRESHOLD = 3
const CLICK_WINDOW_MS = 500

export function useSecretClick(
  ref: RefObject<HTMLElement | null>,
  callback: () => void,
): void {
  const clickTimesRef = useRef<number[]>([])

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const handleClick = () => {
      const now = Date.now()
      clickTimesRef.current.push(now)

      // Keep only clicks within the time window
      clickTimesRef.current = clickTimesRef.current.filter(
        (t) => now - t < CLICK_WINDOW_MS,
      )

      if (clickTimesRef.current.length >= CLICK_THRESHOLD) {
        clickTimesRef.current = []
        callback()
      }
    }

    element.addEventListener('click', handleClick)
    return () => element.removeEventListener('click', handleClick)
  }, [ref, callback])
}
